import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams, Navigate } from "react-router-dom";
import LoggedLayout from 'layouts/LoggedLayout';
import PageHeader from 'components/PageHeader';
import { default as ClockingsService } from 'services/Clockings';
import TopSection from './TopSection';
import MonthsTable from './MonthsTable';
import { NavLink } from "react-router-dom";

export default function Dispenser(props) {
	const [queryParams] = useSearchParams();
	const { id } = useParams();

	const date = queryParams.get('schedule_day');

	const [dispenser, setDispenser] = useState(null);

	useEffect(() => {
		if ( !id || !date ) return;

		let getDispenser = async () => {
			let dispenser = await ClockingsService.getDispenser(id, {
				with_responsibles: true,
				date: date
			});
			setDispenser({...dispenser});
		}
		getDispenser();
	}, [id, date]);


	if (!date) return <Navigate to={'/clockings/dispensers'} />;

	return (
		<LoggedLayout>
			<PageHeader className="mb-3">
				<NavLink to='/clockings/dispensers' className="btn-sm btn-light p-0 px-2 float-start" style={{
					border: '1px solid var(--plenoil-black)',
					background: 'transparent',
					borderRadius: '100%',
					width: '25px',
					height: '25px',
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'nowrap',
					justifyContent: 'center',
					alignItems: 'center',
					marginRight: '5px'
				}}>
					<i className="bi bi-chevron-left" style={{
						fontSize: '1rem',
						lineHeight: '100%',
						color: 'var(--plenoil-black)'
					}}></i>
				</NavLink>
				<span className="header-column header-title">Control de turnos</span>
				<span className="header-column header-icon-end">
					<i className="bi bi-file-spreadsheet text-plenoil-gray"></i>
				</span>
			</PageHeader>

			<div className="col-md-12 px-3 mb-3">
				<TopSection 
					dispenser={dispenser} 
					date={date}
				/>
			</div>
			<div className="col-md-12 px-3">
				<MonthsTable 
					dispenser={dispenser}
				/>
			</div>
		</LoggedLayout>
	);
}